export default "__VITE_ASSET__weXdmajr__"